<template>
    <v-container fluid class="pa-4">
        <!-- Banner Header Principal -->
        <v-card flat outlined class="rounded-xl border-light pa-3 mb-4" style="background-color: #ffffff;">
            <div class="d-flex align-center justify-space-between flex-wrap">
                <div class="d-flex align-center">
                    <v-avatar color="indigo lighten-5" class="mr-3" size="42">
                        <v-icon color="indigo darken-3" size="24">mdi-layers-triple</v-icon>
                    </v-avatar>
                    <div>
                        <div class="text-h6 font-weight-bold grey--text text--darken-4"
                            style="letter-spacing: 0.5px; font-size: 1.15rem !important;">
                            Derivar Parihuelas Abastecidas
                        </div>
                        <div class="text-caption grey--text text--darken-1" style="font-size: 0.75rem !important;">
                            Selección de parihuelas y lotes para asignación de órdenes de producción
                        </div>
                    </div>
                </div>
                <div class="d-flex align-center mt-2 mt-sm-0">
                    <v-btn :color="selected.length > 0 ? 'indigo darken-1' : 'grey lighten-2'"
                        :dark="selected.length > 0"
                        class="font-weight-bold rounded-lg elevation-2 text-none px-4 btn-assign-customers"
                        @click="openDialogAssignCustomers()" :disabled="selected.length === 0">
                        <v-icon left size="20">mdi-account-multiple-plus</v-icon>
                        Asignar Clientes
                    </v-btn>
                </div>
            </div>
        </v-card>

        <!-- Filtros Principales -->
        <v-card flat outlined class="rounded-xl border-light pa-3 mb-4" style="background-color: #fafbfc;">
            <v-row dense align="center">
                <v-col cols="12" sm="6" md="3" lg="2">
                    <s-date label="Fecha Inicio" v-model="filter.BeginDate" @input="loadStretcher"></s-date>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                    <s-date label="Fecha Fin" v-model="filter.EndDate" @input="loadStretcher"></s-date>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                    <s-select-definition :def="1181" label="Destino" v-model="filter.TypeDestiny"
                        @change="onChangeDestiny($event)"></s-select-definition>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                    <s-select-definition :def="1173" label="Cultivo" v-model="filter.TypeCultive"
                        @input="onChangeCultivo($event)"></s-select-definition>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                    <s-select-definition @input="debouncedLoadStretcher" v-model="TypeProcessingPlant"
                        label="Planta Procesadora" :def="1230"></s-select-definition>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                    <s-select-definition :dgr="dgr" label="Línea Empaque" :def="1315" v-model="TypeLineProcess"
                        @input="debouncedLoadStretcher">
                    </s-select-definition>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2" v-if="TypeProcessingPlant == 2">
                    <s-select-definition :def="1226" label="Empacadora" v-model="TypeBaler" clearable
                        @input="debouncedLoadStretcher" />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2" class="d-flex align-center">
                    <v-checkbox v-model="isReprocess" @change="loadStretcher()" label="Reproceso" color="red"
                        hide-details class="mt-0 pt-0"></v-checkbox>
                </v-col>
            </v-row>
        </v-card>

        <!-- Tabla Principal de Lotes / Parihuelas (itemsStretcher) con Multiselect -->
        <v-card flat outlined class="rounded-xl border-light" style="background-color: #ffffff;">
            <div class="d-flex align-center justify-end pa-2">
                <!-- <div class="d-flex align-center">
                    <v-icon color="indigo darken-2" class="mr-2" size="22">mdi-table</v-icon>
                    <span class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
                        Lotes y Parihuelas Disponibles (Stretcher)
                    </span>
                    <v-chip small color="indigo lighten-5" text-color="indigo darken-3" class="ml-3 font-weight-bold">
                        {{ itemsStretcher.length }} registros
                    </v-chip>
                </div> -->
                <div class="d-flex align-center">
                    <v-text-field v-model="searchStretcher" prepend-inner-icon="mdi-magnify"
                        label="Buscar lote / parihuela..." single-line hide-details dense flat solo
                        class="rounded-lg modern-search-input mr-2" style="max-width: 260px;"></v-text-field>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn fab x-small @click="loadStretcher()" v-on="on" color="green darken-2" dark
                                class="hover-scale">
                                <v-icon size="18">mdi-cached</v-icon>
                            </v-btn>
                        </template>
                        <span>Recargar Lotes</span>
                    </v-tooltip>
                </div>
            </div>

            <v-data-table :item-key="filter.TypeDestiny == 1 ? 'RcfID' : 'LppID'" dense :items-per-page="15"
                :items="itemsStretcher" :headers="headersStretcher" v-model="selected" show-select
                :search="searchStretcher" :loading="LoadingStretcher" class="border-light overflow-hidden"
                no-data-text="No se encontraron parihuelas o lotes disponibles.">
                <template v-slot:item.SpdDate="{ item }">
                    {{ item.SpdDate ? moment(item.SpdDate).format('DD/MM/YYYY HH:mm') : '' }}
                </template>
                <template v-slot:item.DateEndCooling="{ item }">
                    {{ item.DateEndCooling ? moment(item.DateEndCooling).format('DD/MM/YYYY HH:mm') : '' }}
                </template>
                <template v-slot:item.RcfID="{ item }">
                    <v-chip small color="blue lighten-5" text-color="blue darken-4" class="font-weight-bold">
                        LP-{{ item.RcfID + "-" + item.RcfCode }}
                    </v-chip>
                </template>
                <template v-slot:item.LppWeightAverageLot="{ item }">
                    <v-chip small color="teal lighten-5" text-color="teal darken-4" class="font-weight-bold">
                        {{ item.LppWeightAverageLot ? parseFloat(item.LppWeightAverageLot).toFixed(2) : '0.00' }} kg
                    </v-chip>
                </template>
                <template v-slot:item.xCount="{ item }">
                    <v-chip x-small :color="item.xCount == 0 ? 'warning' : 'info'">
                        {{ item.xCount == 0 ? 'No' : 'Si: ' + item.xCount }}
                    </v-chip>
                </template>
                <template v-slot:item.Hide="{ item }">
                    <v-btn @click="clickHide(item)" x-small color="error" elevation="0" outlined>
                        <v-icon style="font-size: 16px !important">fas fa-times</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.LppWeightDifference="{ item }">
                    <v-chip small color="success">
                        {{ (item.LppWeightAverageLot - (item.PldWeight || 0)).toFixed(2) }}
                    </v-chip>
                </template>
            </v-data-table>
        </v-card>

        <!-- Dialog modal de vuetify 2 para Asignación de Clientes -->
        <v-dialog v-model="dialogAssignCustomers" max-width="1300px" persistent transition="dialog-bottom-transition">
            <v-card class="rounded-xl overflow-hidden elevation-24 d-flex flex-column"
                style="background-color: #fafbfc; font-family: 'Outfit', 'Inter', sans-serif; max-height: 90vh;">

                <!-- Header con Gradiente Premium -->
                <v-card-title class="d-flex align-center py-3 px-5 white--text flex-shrink-0"
                    style="background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);">
                    <v-icon left color="teal accent-3" class="mr-2" size="24">mdi-account-multiple-plus</v-icon>
                    <div>
                        <div class="text-h6 font-weight-bold"
                            style="letter-spacing: 0.5px; font-size: 1.15rem !important;">
                            Asignar Clientes a Parihuelas</div>
                        <div class="text-caption grey--text text--lighten-2" style="font-size: 0.7rem !important;">
                            Resumen y asignación de órdenes de producción</div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogAssignCustomers = false" class="hover-scale">
                        <v-icon size="20">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-3 flex-grow-1 overflow-y-auto">
                    <!-- Sección de Resumen -->
                    <!-- Tarjetas de KPI principales -->
                    <!-- <div class="">
                        <v-row dense class="mb-0">
                            <v-col cols="12" lg="3" md="4" sm="4">
                                <v-card class="pa-3 rounded-xl d-flex align-center border-light"
                                    style="background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);" flat>
                                    <v-avatar color="blue lighten-4" class="mr-3" size="36">
                                        <v-icon color="blue darken-3" size="20">mdi-basket-outline</v-icon>
                                    </v-avatar>
                                    <div>
                                        <div class="text-caption grey--text text--darken-2 font-weight-bold text-uppercase"
                                            style="font-size: 0.65rem !important; letter-spacing: 0.5px;">Total Jabas
                                        </div>
                                        <div class="text-h6 font-weight-black blue--text text--darken-4"
                                            style="line-height: 1.2;">{{ totalQuantityJabasSum }}</div>
                                    </div>
                                </v-card>
                            </v-col>
                            <v-col cols="12" lg="3" md="4" sm="4">
                                <v-card class="pa-3 rounded-xl d-flex align-center border-light"
                                    style="background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);" flat>
                                    <v-avatar color="green lighten-4" class="mr-3" size="36">
                                        <v-icon color="green darken-3" size="20">mdi-weight-kilogram</v-icon>
                                    </v-avatar>
                                    <div>
                                        <div class="text-caption grey--text text--darken-2 font-weight-bold text-uppercase"
                                            style="font-size: 0.65rem !important; letter-spacing: 0.5px;">
                                            Peso Promedio (TOTAL)
                                        </div>
                                        <div class="text-h6 font-weight-black green--text text--darken-4"
                                            style="line-height: 1.2;">
                                            {{ totalWeightSum.toFixed(6) }} kg
                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                            <v-col cols="12" lg="3" md="4" sm="4">
                                <v-card class="pa-3 rounded-xl d-flex align-center border-light"
                                    style="background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);" flat>
                                    <v-avatar color="purple lighten-4" class="mr-3" size="36">
                                        <v-icon color="purple darken-3" size="20">mdi-layers-outline</v-icon>
                                    </v-avatar>
                                    <div>
                                        <div class="text-caption grey--text text--darken-2 font-weight-bold text-uppercase"
                                            style="font-size: 0.65rem !important; letter-spacing: 0.5px;">Parihuelas
                                        </div>
                                        <div class="text-h6 font-weight-black purple--text text--darken-4"
                                            style="line-height: 1.2;">{{ selected.length }}</div>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div> -->

                    <!-- SECCIÓN 1: Tabla de Lotes Seleccionados (Nuevo Formato) -->
                    <v-row class="mt-1 mb-2" v-if="selected && selected.length > 0">
                        <v-col cols="12">
                            <v-card flat outlined class="rounded-xl border-light overflow-hidden"
                                style="background-color: #ffffff; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);">
                                
                                <!-- Encabezado de la tabla de lotes -->
                                <div class="px-4 py-2 d-flex align-center justify-space-between flex-wrap"
                                    style="background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); border-bottom: 1px solid #e2e8f0;">
                                    <div class="d-flex align-center">
                                        <v-avatar size="28" color="teal lighten-5" class="mr-2">
                                            <v-icon color="teal darken-2" size="18">mdi-table</v-icon>
                                        </v-avatar>
                                        <div>
                                            <span class="font-weight-bold text-subtitle-2 grey--text text--darken-3">
                                                Lotes Seleccionados (Formato Tabla - Nuevo)
                                            </span>
                                            <span class="text-caption grey--text text--darken-1 ml-2 d-none d-sm-inline">
                                                (Haga clic en una fila para seleccionarlo como lote activo)
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-center">
                                        <v-chip x-small color="teal lighten-5" text-color="teal darken-4" class="font-weight-bold mr-2">
                                            {{ selected.length }} {{ selected.length === 1 ? 'lote' : 'lotes' }}
                                        </v-chip>
                                        <span v-if="selectedStretcher && selectedStretcher.length > 0"
                                            class="text-caption font-weight-bold teal--text text--darken-3 d-flex align-center">
                                            <v-icon x-small color="teal darken-2" class="mr-1">mdi-check-circle</v-icon>
                                            Activo: LP-{{ selectedStretcher[0].RcfID }}{{ selectedStretcher[0].RcfCode ? '-' + selectedStretcher[0].RcfCode : '' }}
                                        </span>
                                    </div>
                                </div>

                                <!-- Tabla moderna interactiva de lotes -->
                                <div class="table-responsive" style="overflow-x: auto;">
                                    <v-simple-table dense class="lot-selection-table">
                                        <template v-slot:default>
                                            <thead>
                                                <tr style="background-color: #f8fafc;">
                                                    <th class="text-center font-weight-bold text-caption grey--text text--darken-2" style="width: 50px;">Sel.</th>
                                                    <th class="text-left font-weight-bold text-caption grey--text text--darken-2" style="min-width: 140px;">Lote Producción</th>
                                                    <th class="text-center font-weight-bold text-caption grey--text text--darken-2" style="min-width: 90px;">Parihuela</th>
                                                    <th class="text-left font-weight-bold text-caption grey--text text--darken-2" style="min-width: 110px;">Cultivo</th>
                                                    <th class="text-left font-weight-bold text-caption grey--text text--darken-2" style="min-width: 110px;">Variedad</th>
                                                    <th class="text-left font-weight-bold text-caption grey--text text--darken-2" style="min-width: 150px;">Certificación</th>
                                                    <th class="text-right font-weight-bold text-caption grey--text text--darken-2" style="min-width: 110px;">KG Promedio</th>
                                                    <th class="text-right font-weight-bold text-caption grey--text text--darken-2" style="min-width: 120px;">KG Disponibles</th>
                                                    <th class="text-center font-weight-bold text-caption grey--text text--darken-2" style="width: 100px;">Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(loteItem, idx) in selected" :key="'tbl-' + idx"
                                                    @click="selectLotCard(loteItem)"
                                                    class="cursor-pointer lot-table-row"
                                                    :class="{ 'is-selected': isLotSelected(loteItem) }"
                                                    :style="isLotSelected(loteItem)
                                                        ? 'background-color: #f0fdf4 !important; border-left: 4px solid #10b981;'
                                                        : 'border-left: 4px solid transparent;'">
                                                    
                                                    <!-- Columna Radio / Check -->
                                                    <td class="text-center py-2">
                                                        <v-icon :color="isLotSelected(loteItem) ? 'teal darken-1' : 'grey lighten-1'" size="18">
                                                            {{ isLotSelected(loteItem) ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                                                        </v-icon>
                                                    </td>

                                                    <!-- Columna Lote Producción -->
                                                    <td class="py-2">
                                                        <div class="d-flex align-center">
                                                            <v-chip small :color="isLotSelected(loteItem) ? 'teal lighten-5' : 'blue lighten-5'"
                                                                :text-color="isLotSelected(loteItem) ? 'teal darken-4' : 'blue darken-4'"
                                                                class="font-weight-bold rounded-lg pa-2">
                                                                LP-{{ loteItem.RcfID }}{{ loteItem.RcfCode ? '-' + loteItem.RcfCode : '' }}
                                                            </v-chip>
                                                        </div>
                                                    </td>

                                                    <!-- Columna Parihuela -->
                                                    <td class="text-center py-2">
                                                        <span v-if="loteItem.LlpID" class="font-weight-bold" style="color: #0f766e;">
                                                            {{ loteItem.LlpID }}
                                                        </span>
                                                        <span v-else class="grey--text text--lighten-1">-</span>
                                                    </td>

                                                    <!-- Columna Cultivo -->
                                                    <td class="py-2">
                                                        <span class="font-weight-medium grey--text text--darken-3">
                                                            {{ loteItem.TypeCropName || '-' }}
                                                        </span>
                                                    </td>

                                                    <!-- Columna Variedad -->
                                                    <td class="py-2">
                                                        <span v-if="loteItem.VrtName" class="font-weight-bold px-2 py-1 rounded-lg"
                                                            style="background-color: #f1f5f9; color: #334155; font-size: 0.78rem;">
                                                            {{ loteItem.VrtName }}
                                                        </span>
                                                        <span v-else class="grey--text text--lighten-1">-</span>
                                                    </td>

                                                    <!-- Columna Certificación -->
                                                    <td class="py-2">
                                                        <span v-if="hasCertification(loteItem)"
                                                            class="d-inline-flex align-center font-weight-bold px-2 py-1 rounded-pill"
                                                            style="background: #dcfce7; color: #047857; font-size: 0.75rem;">
                                                            <v-icon x-small color="#047857" class="mr-1">mdi-check-decagram</v-icon>
                                                            {{ loteItem.TcDescription }}
                                                        </span>
                                                        <span v-else class="grey--text text--lighten-1 text-caption">Sin Certificación</span>
                                                    </td>

                                                    <!-- Columna KG Promedio -->
                                                    <td class="text-right py-2 font-weight-medium grey--text text--darken-3">
                                                        {{ parseFloat(loteItem.LppWeightAverageLot || 0).toFixed(2) }} kg
                                                    </td>

                                                    <!-- Columna KG Disponibles -->
                                                    <td class="text-right py-2">
                                                        <span class="font-weight-black success--text text--darken-2" style="font-size: 0.88rem;">
                                                            <v-icon x-small color="success" class="mr-1">mdi-scale-balance</v-icon>
                                                            {{ (parseFloat(loteItem.LppWeightAverageLot || 0) - parseFloat(loteItem.PldWeight || 0)).toFixed(2) }} kg
                                                        </span>
                                                    </td>

                                                    <!-- Columna Estado / Acción -->
                                                    <td class="text-center py-2">
                                                        <v-chip x-small
                                                            :color="isLotSelected(loteItem) ? 'teal' : 'grey lighten-3'"
                                                            :text-color="isLotSelected(loteItem) ? 'white' : 'grey darken-2'"
                                                            class="font-weight-bold">
                                                            {{ isLotSelected(loteItem) ? '✓ ACTIVO' : 'SELECCIONAR' }}
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- Sección de Tabla de Órdenes de Producción -->
                    <v-row class="mt-2">
                        <v-col cols="12">
                            <v-card flat outlined class="rounded-xl border-light"
                                style="padding: 8px 10px; background-color: #f8fafc;">
                                <div class="d-flex align-center justify-space-between mb-2">
                                    <div class="d-flex align-center">
                                        <v-icon color="indigo darken-2" class="mr-2"
                                            size="20">mdi-feature-search-outline</v-icon>
                                        <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3">
                                            Buscador y Selector de Orden de Producción:
                                        </span>
                                    </div>
                                    <div class="d-flex align-center">
                                        <!-- Buscador de orden de producción que funcionaba a la tabla (comentado) -->
                                        <!-- <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                                            label="Buscar orden de producción..." single-line hide-details dense flat solo
                                            class="rounded-lg modern-search-input" style="max-width: 200px;"></v-text-field> -->

                                        <!-- Spans / Chips de contadores de disponibles y seleccionados -->
                                        <v-chip x-small color="grey lighten-4" text-color="grey darken-3" class="font-weight-bold mr-1">
                                            {{ availableOrdersSearch.length }} disponibles
                                        </v-chip>
                                        <v-chip v-if="selectedSearch && selectedSearch.length > 0" x-small color="indigo lighten-5" text-color="indigo darken-4" class="font-weight-bold">
                                            {{ selectedSearch.length }} seleccionada{{ selectedSearch.length > 1 ? 's' : '' }}
                                        </v-chip>
                                    </div>
                                </div>

                                <!-- Selector Searchable de Órdenes de Producción (Uno a Uno con Confirmar) -->
                                <div class="mb-3 pa-2 rounded-xl" style="background-color: #ffffff; border: 1px solid #e2e8f0; box-shadow: 0 1px 3px rgba(0,0,0,0.03);">
                                    <div class="d-flex align-center">
                                        <v-autocomplete
                                            v-model="orderToSelect"
                                            :items="availableOrdersSearch"
                                            item-value="UwoOrderProductionID"
                                            item-text="UwoCustomerName"
                                            :filter="filterOrderProduction"
                                            return-object
                                            clearable
                                            outlined
                                            dense
                                            hide-details
                                            prepend-inner-icon="mdi-magnify"
                                            placeholder="Buscar orden por cliente, OP, plantilla, cultivo, centro..."
                                            class="rounded-lg modern-search-autocomplete flex-grow-1"
                                            :menu-props="{ maxHeight: '380px', offsetY: true, contentClass: 'elevation-6 rounded-xl border-light' }"
                                            no-data-text="No hay órdenes de producción disponibles para seleccionar."
                                        >
                                            <!-- Custom Selection cuando se selecciona una orden -->
                                            <template v-slot:selection="{ item }">
                                                <div class="d-flex align-center text-truncate py-1">
                                                    <v-chip x-small color="indigo lighten-5" text-color="indigo darken-4" class="font-weight-black mr-2 px-2 flex-shrink-0">
                                                        OP: {{ item.UwoOrderProductionID }}
                                                    </v-chip>
                                                    <span class="font-weight-bold grey--text text--darken-4 text-truncate mr-2">
                                                        {{ item.UwoCustomerName || 'Sin Cliente' }}
                                                    </span>
                                                    <span v-if="item.UwoMaterialListID" class="grey--text text-caption flex-shrink-0 mr-2">
                                                        (Plantilla: {{ item.UwoMaterialListID }})
                                                    </span>
                                                    <span v-if="item.TypeCultiveName" class="green--text text--darken-2 font-weight-bold text-caption flex-shrink-0">
                                                        {{ item.TypeCultiveName }}
                                                    </span>
                                                </div>
                                            </template>

                                            <!-- Custom Item en el Dropdown -->
                                            <template v-slot:item="{ item }">
                                                <div class="d-flex align-center w-100 py-2 border-bottom-item" style="width: 100%;">
                                                    <div class="mr-3 flex-shrink-0">
                                                        <v-avatar size="26" color="indigo lighten-5">
                                                            <v-icon size="14" color="indigo darken-2">mdi-plus</v-icon>
                                                        </v-avatar>
                                                    </div>

                                                    <!-- Detalle de la Orden -->
                                                    <div class="flex-grow-1 overflow-hidden">
                                                        <!-- Fila 1: Cliente & Chips (OP y Tipo Cultivo) -->
                                                        <div class="d-flex justify-space-between align-center mb-1">
                                                            <div class="d-flex align-center overflow-hidden mr-2">
                                                                <v-icon small color="indigo darken-1" class="mr-1">mdi-account-circle-outline</v-icon>
                                                                <span class="font-weight-bold text-subtitle-2 grey--text text--darken-4 text-truncate">
                                                                    {{ item.UwoCustomerName || 'Sin Cliente' }}
                                                                </span>
                                                            </div>
                                                            <div class="d-flex align-center flex-shrink-0">
                                                                <v-chip x-small color="indigo lighten-5" text-color="indigo darken-4" class="font-weight-black px-2 mr-1">
                                                                    OP: {{ item.UwoOrderProductionID }}
                                                                </v-chip>
                                                                <v-chip x-small v-if="item.TypeCropName"
                                                                    :color="item.TypeCropName === 'ORGÁNICO' ? 'green lighten-5' : 'blue-grey lighten-5'"
                                                                    :text-color="item.TypeCropName === 'ORGÁNICO' ? 'green darken-3' : 'blue-grey darken-3'"
                                                                    class="font-weight-bold px-2">
                                                                    {{ item.TypeCropName }}
                                                                </v-chip>
                                                            </div>
                                                        </div>

                                                        <!-- Fila 2: Plantilla, Cultivo, Variedad -->
                                                        <div class="d-flex align-center flex-wrap text-caption grey--text text--darken-2 mb-1" style="gap: 12px; font-size: 0.78rem !important;">
                                                            <span v-if="item.UwoMaterialListID" class="d-flex align-center">
                                                                <v-icon x-small color="grey darken-1" class="mr-1">mdi-file-document-outline</v-icon>
                                                                <b class="mr-1">Plantilla:</b>{{ item.UwoMaterialListID }}
                                                                <span v-if="item.UwoMaterialListName" class="grey--text text--darken-1 ml-1 text-truncate" style="max-width: 180px;">
                                                                    ({{ item.UwoMaterialListName }})
                                                                </span>
                                                            </span>
                                                            <span v-if="item.TypeCultiveName" class="d-flex align-center">
                                                                <v-icon x-small color="green darken-2" class="mr-1">mdi-sprout-outline</v-icon>
                                                                <b class="mr-1">Cultivo:</b>{{ item.TypeCultiveName }}
                                                                <span v-if="item.VrtName" class="ml-1 font-weight-medium">({{ item.VrtName }})</span>
                                                            </span>
                                                        </div>

                                                        <!-- Fila 3: Peso Planificado, Cajas, Centro y Planta -->
                                                        <div class="d-flex align-center justify-space-between flex-wrap text-caption pt-1" style="border-top: 1px dashed #e2e8f0; font-size: 0.75rem !important;">
                                                            <div class="d-flex align-center" style="gap: 12px;">
                                                                <span class="d-flex align-center font-weight-bold success--text">
                                                                    <v-icon x-small color="success" class="mr-1">mdi-scale-balance</v-icon>
                                                                    {{ item.UwoPlannedQty ? parseFloat(item.UwoPlannedQty).toLocaleString() + ' kg' : '0 kg' }}
                                                                </span>
                                                                <span v-if="item.UwoMaterialListNumberBoxes" class="d-flex align-center grey--text text--darken-2">
                                                                    <v-icon x-small color="blue-grey" class="mr-1">mdi-package-variant-closed</v-icon>
                                                                    <b class="mr-1">Cajas:</b>{{ item.UwoMaterialListNumberBoxes }}
                                                                </span>
                                                            </div>
                                                            <div class="d-flex align-center grey--text text--darken-1" style="gap: 10px;">
                                                                <span v-if="item.UfdProductionCenter" class="d-flex align-center">
                                                                    <v-icon x-small color="grey" class="mr-1">mdi-domain</v-icon>
                                                                    {{ item.UfdProductionCenter }}
                                                                </span>
                                                                <span v-if="item.UwoPlantProcessing" class="d-flex align-center">
                                                                    <v-icon x-small color="grey" class="mr-1">mdi-factory</v-icon>
                                                                    {{ item.UwoPlantProcessing }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <!-- No data slot -->
                                            <template v-slot:no-data>
                                                <v-list-item>
                                                    <v-list-item-content class="text-center py-3">
                                                        <v-icon color="grey lighten-1" class="mb-1">mdi-alert-circle-outline</v-icon>
                                                        <span class="grey--text text--darken-1 caption">
                                                            No hay órdenes de producción disponibles para seleccionar.
                                                        </span>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete>

                                        <!-- Botón Confirmar Selección (Siempre visible pero disabled cuando no hay orden seleccionada) -->
                                        <v-btn
                                            color="indigo darken-2"
                                            dark
                                            depressed
                                            class="ml-2 rounded-lg font-weight-bold text-none px-4 flex-shrink-0 btn-confirm-order"
                                            style="height: 40px;"
                                            :disabled="!orderToSelect"
                                            @click="confirmAddOrder"
                                        >
                                            <v-icon left size="18">mdi-check-circle-outline</v-icon>
                                            Confirmar
                                        </v-btn>
                                    </div>
                                </div>

                                <!-- <v-data-table item-key="UwoOrderProductionID" dense fixed-header=""
                                    v-model="selectedSearch" :items="itemsSearch" :headers="headersSearch"
                                    :items-per-page="5" :search="search" @click:row="rowClickSearch" show-select
                                    :single-select="false" class="elevation-2 rounded-xl border-light overflow-hidden"
                                    no-data-text="No se encontraron órdenes de producción disponibles.">
                                    <template v-slot:item.UwoOrderProductionID="{ item }">
                                        <v-chip small color="indigo lighten-5" text-color="indigo darken-3"
                                            class="font-weight-bold rounded-lg pa-2" style="font-size: 10px;">
                                            {{ item.UwoOrderProductionID }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.UwoMaterialListNumberBoxes="{ item }">
                                        <span class="font-weight-bold">{{ item.UwoMaterialListNumberBoxes }}</span>
                                    </template>
                                    <template v-slot:item.UwoPlannedQty="{ item }">
                                        <span class="font-weight-bold success--text">{{ item.UwoPlannedQty }}</span>
                                    </template>
                                </v-data-table> -->
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- Tabla de Lotes Seleccionados -->
                    <!-- <v-row class="mt-2">
                        <v-col cols="12">
                            <v-card flat outlined class="rounded-xl border-light pa-2"
                                style="background-color: #ffffff;">
                                <div class="d-flex align-center justify-space-between mb-2">
                                    <div class="d-flex align-center">
                                        <v-icon color="teal darken-2" class="mr-2" size="20">mdi-layers-triple</v-icon>
                                        <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3">
                                            Lotes Seleccionados
                                        </span>
                                    </div>
                                    <span class="text-caption grey--text font-weight-bold">
                                        Haga clic en un lote para seleccionarlo y armar el detalle de cajas
                                    </span>
                                </div>

                                <v-data-table :item-key="filter.TypeDestiny == 1 ? 'RcfID' : 'LppID'" dense
                                    :items-per-page="5" :items="selected" :headers="headersStretcherModal"
                                    v-model="selectedStretcher" @click:row="rowClickStretcher" single-select
                                    class="elevation-1 rounded-xl border-light overflow-hidden">
                                    <template v-slot:item.SpdDate="{ item }">
                                        {{ item.SpdDate ? moment(item.SpdDate).format('DD/MM/YYYY HH:mm') : '' }}
                                    </template>
                                    <template v-slot:item.DateEndCooling="{ item }">
                                        {{ item.DateEndCooling ? moment(item.DateEndCooling).format('DD/MM/YYYY HH:mm')
                                            : '' }}
                                    </template>
                                    <template v-slot:item.RcfID="{ item }">
                                        <v-chip small color="blue lighten-5" text-color="blue darken-4"
                                            class="font-weight-bold">
                                            LP-{{ item.RcfID + "-" + item.RcfCode }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.LppWeightDifference="{ item }">
                                        <v-chip small color="success">
                                            {{ (item.LppWeightAverageLot - (item.PldWeight || 0)).toFixed(2) }}
                                        </v-chip>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row> -->

                    <!-- Selected Items Cards -->
                    <v-row dense class="mt-2" v-if="selectedSearch.length > 0">
                        <v-col cols="12">
                            <v-card flat outlined class="rounded-xl border-light pa-2"
                                style="background-color: #f8fafc;">
                                <div
                                    class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-2 d-flex align-center">
                                    <v-icon color="indigo darken-2" class="mr-2" size="20">mdi-checkbox-multiple-marked
                                    </v-icon>
                                    Órdenes de Producción Seleccionadas
                                </div>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="4" v-for="(item, idx) in selectedSearch" :key="idx">
                                        <v-card
                                            class="border-light rounded-xl pa-3 fill-height d-flex flex-column justify-space-between elevation-1"
                                            style="background-color: #ffffff;">
                                            <div>
                                                <div class="d-flex justify-space-between align-center mb-1">
                                                    <span
                                                        class="text-body-2 font-weight-bold text--darken-4 text-truncate mr-2"
                                                        style="font-size: 0.9rem !important; max-width: 65%;"
                                                        :title="item.UwoCustomerName">
                                                        {{ item.UwoCustomerName }}
                                                    </span>
                                                    <div class="d-flex align-center flex-shrink-0">
                                                        <v-chip small color="indigo lighten-5" text-color="indigo darken-4"
                                                            class="font-weight-bold rounded-lg mr-1">
                                                            OP: {{ item.UwoOrderProductionID }}
                                                        </v-chip>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    color="red darken-2"
                                                                    class="rounded-lg ml-1"
                                                                    style="background-color: #fef2f2; border: 1px solid #fecaca; width: 26px; height: 26px;"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    @click="removeSelectedOrder(item, idx)"
                                                                >
                                                                    <v-icon size="16">mdi-trash-can-outline</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Quitar orden</span>
                                                        </v-tooltip>
                                                    </div>
                                                </div>

                                                <v-divider class="my-1"></v-divider>
                                                <div class="mt-1">
                                                    <div class="d-flex justify-space-between text-body-2 mb-1"
                                                        style="font-size: 0.9rem !important;">
                                                        <span class="grey--text text--darken-1 font-weight-medium">
                                                            Cultivo / Variedad:</span>
                                                        <span
                                                            class="font-weight-black text-right grey--text text--darken-3">
                                                            {{ item.TypeCultiveName }}
                                                            {{ item.TypeCropName }}
                                                            {{ item.VrtName }}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex justify-space-between text-body-2 mb-1"
                                                        style="font-size: 0.9rem !important;">
                                                        <span class="grey--text text--darken-1 font-weight-medium">
                                                            Producto:</span>
                                                        <span class="font-weight-bold text-right text--darken-3">
                                                            {{ item.UwoMaterialListName }}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex justify-space-between text-body-2 mb-1"
                                                        style="font-size: 0.9rem !important;">
                                                        <span class="grey--text text--darken-1 font-weight-medium">
                                                            Planta Proc:</span>
                                                        <span class="font-weight-bold text-right text--darken-3">
                                                            {{ item.UwoPlantProcessing }}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex justify-space-between align-center text-body-2 mb-1"
                                                        style="font-size: 0.9rem !important;">
                                                        <span class="grey--text text--darken-1 font-weight-medium">
                                                            Lote Seleccionado:</span>
                                                        <v-chip small color="teal lighten-5" text-color="teal darken-4"
                                                            class="font-weight-bold rounded-lg pa-2">
                                                            {{ RcfIDCheck ? 'LP-' + RcfIDCheck : (selected.length === 1
                                                                &&
                                                                selected[0] ? 'LP-' + selected[0].RcfID : 'No seleccionado')
                                                            }}
                                                        </v-chip>
                                                    </div>
                                                </div>

                                                <!-- Presentation Select, Calibre and Calculations -->
                                                <v-divider class="my-2"></v-divider>
                                                <v-row dense class="mt-1" align="center">
                                                    <v-col cols="12" sm="6">
                                                        <s-select-definition :def="1274" label="PRESENTACIÓN"
                                                            v-model="item.PresentationBoxID"
                                                            @getDataInitial="onGetPresentations"
                                                            @input="calculatePresentationBox(item)" clearable />
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <s-select-definition :def="1266" label="Calibre"
                                                            v-model="objCaliber" return-object ref="TypeCaliber"
                                                            @input="inputCaliber($event)"></s-select-definition>
                                                    </v-col>
                                                    <v-col cols="8">
                                                        <div>
                                                            <v-label><b>CAJAS</b></v-label>
                                                            <v-text-field dense outlined hide-details type="number"
                                                                v-model.number="item.qtyBoxesToCreate"
                                                                @input="validateBoxesInput(item)" />
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="4" class="d-flex align-center justify-center"
                                                        style="padding-top: 16px;">
                                                        <v-btn color="success" small class="rounded-lg font-weight-bold"
                                                            elevation="1" @click="addPresentationToArray(item)"
                                                            :disabled="!item.qtyBoxesToCreate || item.qtyBoxesToCreate <= 0">
                                                            <v-icon left small>mdi-plus</v-icon> Agregar
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                                <!-- Calculations results and inputs -->
                                                <div v-if="item.PresentationBoxID" class="mt-2 text-body-2">
                                                    <div class="d-flex justify-space-between mb-1">
                                                        <span class="grey--text text--darken-1">Cajas Máx.
                                                            (Lote):</span>
                                                        <span class="font-weight-bold blue--text">
                                                            {{ item.calculatedBoxes }}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex justify-space-between mb-1">
                                                        <span class="grey--text text--darken-1">KG a usar:</span>
                                                        <span class="font-weight-bold primary--text">
                                                            {{ ((item.qtyBoxesToCreate || 0) *
                                                                getPresentationHelper(item)).toFixed(2) }} kg
                                                        </span>
                                                    </div>
                                                    <div class="d-flex justify-space-between mb-1">
                                                        <span class="grey--text text--darken-1">Saldo Disp.
                                                            (Lote):</span>
                                                        <span class="font-weight-bold orange--text">
                                                            {{ Math.max(0, getSelectedLotAvailableWeight() -
                                                                ((item.qtyBoxesToCreate ||
                                                                    0) *
                                                                    getPresentationHelper(item))).toFixed(2) }} kg
                                                        </span>
                                                    </div>
                                                    <div class="d-flex justify-space-between mb-1">
                                                        <span class="grey--text text--darken-1">Saldo Disp.
                                                            (Cliente):</span>
                                                        <span class="font-weight-bold success--text">
                                                            {{ Math.max(0, item.UwoPlannedQty - getTotalUsedWeight(item)
                                                                -
                                                                ((item.qtyBoxesToCreate || 0) *
                                                                    getPresentationHelper(item))).toFixed(2) }} kg
                                                        </span>
                                                    </div>
                                                </div>

                                                <!-- Added Presentations list -->
                                                <div v-if="item.presentationsAdded && item.presentationsAdded.length > 0"
                                                    class="mt-3">
                                                    <div class="text-caption font-weight-bold grey--text text-uppercase mb-1"
                                                        style="font-size: 0.75rem !important;">
                                                        Presentaciones Agregadas:
                                                    </div>
                                                    <v-simple-table dense
                                                        class="border-light rounded-lg overflow-hidden mb-2"
                                                        style="background-color: #f8fafc;">
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr class="grey lighten-4">
                                                                    <th class="text-left text-caption font-weight-bold py-1 px-2"
                                                                        style="height: 32px; font-size: 0.85rem !important; color: #475569 !important;">
                                                                        Presentación</th>
                                                                    <th class="text-center text-caption font-weight-bold py-1 px-2"
                                                                        style="width: 70px; height: 32px; font-size: 0.85rem !important; color: #475569 !important;">
                                                                        Lote</th>
                                                                    <th class="text-center text-caption font-weight-bold py-1 px-2"
                                                                        style="width: 70px; height: 32px; font-size: 0.85rem !important; color: #475569 !important;">
                                                                        Cajas</th>
                                                                    <th class="text-right text-caption font-weight-bold py-1 px-2"
                                                                        style="width: 70px; height: 32px; font-size: 0.85rem !important; color: #475569 !important;">
                                                                        Total KG</th>
                                                                    <th class="text-center text-caption font-weight-bold py-1 px-2"
                                                                        style="width: 35px; height: 32px;"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(pres, pIdx) in item.presentationsAdded"
                                                                    :key="pIdx" class="table-row-hover">
                                                                    <td class="text-left text-body-2 py-1 px-2 font-weight-medium text-truncate"
                                                                        style="max-width: 110px; height: 38px;"
                                                                        :title="pres.PresentationBoxName">
                                                                        {{ pres.PresentationBoxName }}
                                                                    </td>
                                                                    <td class="text-center py-1 px-1"
                                                                        style="height: 38px;">
                                                                        <v-chip small color="teal lighten-5"
                                                                            text-color="teal darken-4"
                                                                            class="font-weight-bold rounded-lg pa-1 text-caption">
                                                                            LP-{{ pres.RcfID }}
                                                                        </v-chip>
                                                                    </td>
                                                                    <td class="text-center py-1 px-1"
                                                                        style="height: 38px;">
                                                                        <v-text-field v-model.number="pres.QtyBoxes"
                                                                            type="number" dense outlined hide-details
                                                                            class="custom-center-input font-weight-bold"
                                                                            style="font-size: 0.85rem;"
                                                                            @focus="pres._prevQtyBoxes = pres.QtyBoxes"
                                                                            @input="debouncedUpdatePresentationQty(item, pres)" />
                                                                    </td>
                                                                    <td class="text-right text-body-2 py-1 px-2 font-weight-bold primary--text"
                                                                        style="height: 38px;">
                                                                        {{ pres.TotalWeight.toFixed(2) }}
                                                                    </td>
                                                                    <td class="text-center py-1 px-1"
                                                                        style="height: 38px;">
                                                                        <v-btn icon x-small color="red"
                                                                            @click="removePresentationFromArray(item, pIdx)">
                                                                            <v-icon x-small>mdi-delete</v-icon>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </div>
                                            </div>

                                            <div class="d-flex justify-space-between align-center">
                                                <div>
                                                    <div class="text-caption grey--text" style="font-size: 0.75rem;">
                                                        Planificado
                                                    </div>
                                                    <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3"
                                                        style="line-height: 1.2;">
                                                        {{ item.UwoPlannedQty }} kg
                                                    </div>
                                                </div>
                                                <div class="text-right">
                                                    <div class="text-caption grey--text" style="font-size: 0.75rem;">
                                                        Peso Usado
                                                    </div>
                                                    <div class="text-h6 font-weight-black success--text text--darken-3"
                                                        style="line-height: 1.2;">
                                                        {{ getTotalUsedWeight(item).toFixed(2) }} kg
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- Detalle || Configuración de Empaque -->
                    <!-- <v-row class="mt-2" v-if="viewItemSearch.UwoOrderProductionID !== undefined">
                        <v-col cols="12">
                            <v-card flat outlined class="rounded-xl border-light"
                                style="padding: 8px 10px; background-color: #f8fafc;">
                                <div class="d-flex align-center justify-space-between mb-3 pb-2"
                                    style="border-bottom: 1px solid #e2e8f0;">
                                    <div class="d-flex align-center">
                                        <v-icon color="indigo darken-2" class="mr-2" size="20">mdi-cog-outline</v-icon>
                                        <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3">
                                            Detalle || Configuración de Empaque
                                        </span>
                                    </div>
                                    <span class="text-caption red--text font-weight-bold">
                                        * Campos Obligatorios
                                    </span>
                                </div>
                                <v-row align="center" dense>
                                    <v-col cols="12" sm="4" md="3">
                                        <s-select-definition v-model="TypeProcessingPlant" label="Planta Procesadora"
                                            :def="1230"></s-select-definition>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3">
                                        <s-select-definition :dgr="dgr" label="Linea Empaque" :def="1315"
                                            v-model="TypeLineProcess"></s-select-definition>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="3" v-if="TypeProcessingPlant == 2">
                                        <s-select-definition :def="1226" label="Empacadora" v-model="TypeBaler"
                                            clearable />
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row> -->



                    <!-- Formulario de Adición de Cajas -->
                    <!-- <v-row class="mt-2"
                        v-if="viewItemSearch.UwoOrderProductionID !== undefined && selectedStretcher.length > 0">
                        <v-col cols="12">
                            <v-row dense align="center">
                                <v-col cols="6" sm="2">
                                    <s-text label="LP Seleccionado" v-model="RcfIDCheck" readonly />
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <s-text label="Nro. Cajas" number :min="0" v-model="Quantity" ref="Quantity">
                                        <template v-slot:append>
                                            <i style="color: red; font-size: 7px;" class="fa fa-asterisk"></i>
                                        </template>
                                    </s-text>
                                </v-col>
                                <v-col cols="6" sm="3">
                                    <s-select-definition :def="1266" label="Calibre" v-model="objCaliber" return-object
                                        ref="TypeCaliber" @input="inputCaliber($event)"></s-select-definition>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <s-text label="Fruta x Caja:" v-model="pldFruitxBoxe" number :min="1"
                                        ref="pldFruitxBoxe">
                                        <template v-slot:append>
                                            <i style="color: red; font-size: 9px;" class="fa fa-asterisk"></i>
                                        </template>
                                    </s-text>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <v-text-field label="Cajas disponibles (Aprox.)" readonly
                                        v-model="boxeAproximate"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="1" class="d-flex justify-center align-center">
                                    <v-btn small color="info" elevation="0" fab @click="newItem()">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row> -->

                    <!-- Detalle de Lotes Agregados -->
                    <!-- <v-row class="mt-2"
                        v-if="viewItemSearch.UwoOrderProductionID !== undefined && itemsDetail.length > 0">
                        <v-col cols="12">
                            <div class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-2">Detalles
                                Agregados
                            </div>
                            <v-data-table item-key="PldLine" dense :items-per-page="-1" :items="itemsDetail"
                                :headers="headersDetail" hide-default-footer
                                class="elevation-2 rounded-lg border-light overflow-hidden">
                                <template v-slot:item.Actions="{ item }">
                                    <v-btn @click="removeItem(item)" x-small color="error" elevation="0" block>
                                        <v-icon style="font-size: 16px !important">fas fa-times</v-icon>
                                    </v-btn>
                                </template>
                                <template v-slot:item.TypeCaliberName="{ item }">
                                    <s-select-definition :def="1266" v-model="item.TypeCaliber"></s-select-definition>
                                </template>
                                <template v-slot:item.PldFruitxBoxe="{ item }">
                                    <s-text number v-model="item.PldFruitxBoxe"></s-text>
                                </template>
                                <template v-slot:item.PldQuantityBoxes="{ item }">
                                    <s-text readonly number v-model="item.PldQuantityBoxes"
                                        @input="inputSumBoxes()"></s-text>
                                </template>
                            </v-data-table>
                            <div class="mt-2 d-flex justify-space-between align-center">
                                <b class="text-subtitle-2">Total Cajas: {{ sumTotalBoxes }}</b>
                                <b v-if="viewItemSearch.UwoMaterialListNumberBoxes == sumTotalBoxes"
                                    style="color: red; font-family: Courier; font-size: 10px;">
                                    Atención !!! Cantidad de cajas coincide con cant. cajas de presentación
                                </b>
                                <b v-if="viewItemSearch.UwoMaterialListNumberBoxes == sumTotalBoxes"
                                    style="color: red; font-family: Courier; font-size: 10px;">
                                    {{ difTypeLine() }}
                                </b>
                            </div>
                        </v-col>
                    </v-row> -->
                </v-card-text>

                <!-- Acciones del Modal -->
                <v-card-actions class="px-5 py-3 grey lighten-4 d-flex justify-end border-top flex-shrink-0">
                    <v-btn color="success" dark depressed @click="saveAssignment()"
                        class="text-none font-weight-bold rounded-lg px-4 mr-2" :disabled="itemsDetail.length === 0">
                        Guardar Detalle
                    </v-btn>
                    <v-btn color="red" dark depressed @click="dialogAssignCustomers = false"
                        class="text-none font-weight-bold rounded-lg px-4">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from "moment";
import debounce from 'lodash/debounce';
import _sSupplying from "@/services/FreshProduction/SupplyingOfLotsService";
import _sPackingService from "@/services/FreshProduction/PackingService";
import _sGenParamService from "@/services/General/ParameterService";


export default {
    components: {},
    data() {
        return {
            OrdAreProduction: '',
            RcfIDCheck: '',
            itemsSearch: [],
            selected: [],
            selectedSearch: [],
            orderToSelect: null,
            viewItemSearch: {},
            search: "",
            dialogAssignCustomers: false,
            config: {
                service: _sSupplying,
                model: {
                    SppID: "ID",
                },
                headers: [
                    { text: "Parihuela", value: "LlpID", width: 80 },
                    { text: "Lote Producción", value: "RcfCode", width: 150 },
                    { text: "Destino", value: "TypeDestinyName", width: 80 },
                    { text: "Linea Proceso", value: "TypeLineProcessName", width: 100 },
                    // { text: "Linea Negocio", value: "TypeBsnLineName", width: 100 },
                    { text: "Cant. Jabas", value: "SppQuantityJaba", width: 80 },
                    { text: "Peso Promedio", value: "WeightAverageParihuela", width: 100 },
                    { text: "Calibre", value: "TypeCaliberName", width: 90 },
                    { text: "Tipo Cultivo", value: "TypeCropName", width: 100 },
                    { text: "Cultivo", value: "TypeCultiveName", width: 100 },
                    { text: "Variedad", value: "VrtName", width: 100 },
                    { text: "Certificación", value: "TypeCertificationName", width: 200 },
                    { text: "Linea Proceso", value: "TypeLineProcessName", width: 100 },
                    { text: "Planta Procesadora", value: "TypeProcessingPlantName", width: 120 },
                ]
            },
            headersSearch: [
                { text: "Plantilla", value: "UwoMaterialListID", width: 90, },
                // { text: "Nro. Orden Produccion", value: "UwoOrderProductionID", width: 120, },
                { text: "Cliente", value: "UwoCustomerName", width: 250 },
                { text: "Cultivo", value: "TypeCultiveName", width: 100 },
                { text: "Tipo Cultivo", value: "TypeCropName", width: 100 },
                { text: "Centro de Produccion", value: "UfdProductionCenter", width: 150 },
                // { text: "Cantidad", value: "UwoMaterialListNumberBoxes", width: 50, },
                { text: "Peso", value: "UwoPlannedQty", width: 70, align: "center" },
                // { text: "KG x Caja", value: "NumInSaleString", width: 80 },
                { text: "Planta Proc.", value: "UwoPlantProcessing", width: 60 },
            ],
            filter: {
                BeginDate: '2026-03-25',
                EndDate: '2026-03-25',
                TypeDestiny: 1,
                TypeCultive: 0
            },
            LoadingStretcher: false,
            TypeLineProcess: 0,
            dgr: 0,
            isReprocess: false,
            searchStretcher: "",
            itemsStretcher: [],
            selectedStretcher: [],
            selected: [],
            headersStretcher: [
                { text: "F. Abast.", value: "SpdDate", width: 110 },
                { text: "Lote Produccion", value: "RcfID", width: 120 },
                { text: "Procedencia", value: "TypeZonLocationName", width: 140 },
                { text: "Certificación", value: "TcDescription", width: 180 },
                { text: "Tipo Cultivo", value: "TypeCropName", width: 110 },
                { text: "Variedad", value: "VrtName", width: 110 },
                { text: "Parihuela", value: "LlpID", width: 100 },
                { text: "KG promedio", value: "LppWeightAverageLot", width: 110 },
                { text: "KG Abastecidos", value: "PldWeight", width: 110 },
                { text: "KG Disponibles", value: "LppWeightDifference", width: 110 },
                // { text: "Ocultar", value: "Hide", width: 70 },
                { text: "Usado", value: "xCount", width: 70 },
                { text: "Fec. Tratamiento", value: "DateEndCooling", width: 120 },
                { text: "Lote", value: "RcfCode", width: 80 },
            ],
            headersStretcherModal: [
                { text: "Lote Producción", value: "RcfID", width: 130 },
                // { text: "Parihuela", value: "LlpID", width: 90 },
                { text: "Tipo Cultivo", value: "TypeCropName", width: 110 },
                { text: "Variedad", value: "VrtName", width: 110 },
                { text: "KG Promedio", value: "LppWeightAverageLot", width: 110 },
                { text: "KG Disponibles", value: "LppWeightDifference", width: 110 },
                // { text: "F. Abast.", value: "SpdDate", width: 120 },
            ],
            headersDetail: [
                { text: "ParH", value: "LlpID", width: 40 },
                { text: "Acciones", value: "Actions", width: 60 },
                { text: "Variedad", value: "VrtName", width: 120 },
                { text: "Calibre", value: "TypeCaliberName", width: 150 },
                { text: "Fruta x Caja", value: "PldFruitxBoxe", width: 100 },
                { text: "Nro. Lote", value: "RcfID", width: 100 },
                { text: "Procedencia", value: "TypeZonLocationName", width: 100 },
                { text: "Correlativo. Lote", value: "RcfCode", width: 100 },
                { text: "Cantidad", value: "PldQuantityBoxes", width: 250 },
            ],
            itemsDetail: [],
            itemsDetailRemoved: [],
            objCaliber: null,
            pldFruitxBoxe: 1,
            sumTotalBoxes: 0,
            itemRemoved: [],
            typeBalance: true,
            TypeDestiny: 0,
            VrtID: 0,
            TypeProcessingPlant: null,
            TypeBaler: null,
            Quantity: 0,
            RcfIDCheck: 0,
            boxeAproximate: 0,
            ParamValidate: null,
            SecCreate: null,
            presentationsList: []
        };
    },
    created() {
        this.moment = moment;
        this.debouncedLoadStretcher = debounce(this.loadStretcher, 300);
        this.debouncedUpdatePresentationQty = debounce(this.updatePresentationQty, 400);
        this.loadStretcher();
    },
    computed: {
        availableOrdersSearch() {
            if (!this.itemsSearch) return [];
            const selectedIds = new Set((this.selectedSearch || []).map(x => x.UwoOrderProductionID));
            return this.itemsSearch.filter(x => !selectedIds.has(x.UwoOrderProductionID));
        },
        summaryGrouped() {
            if (!this.selected || this.selected.length === 0) return [];

            const groups = {};
            this.selected.forEach(item => {
                const key = `${item.TypeDestiny || this.filter.TypeDestiny || 0}-${item.TypeLineProcess || 0}-${item.TypeProcessingPlant || 0}-${item.TypeCultive || this.filter.TypeCultive || 0}-${item.TypeCrop || 0}-${item.VrtID || 0}`;
                const quantity = parseFloat(item.LlpQuantityJaba ?? item.SppQuantityJaba ?? item.QuantityJaba ?? item.Quantity ?? item.xCount ?? 0);
                const weight = parseFloat(item.WeightAverageParihuela ?? item.LppWeightAverageLot ?? item.PldWeight ?? 0);

                if (!groups[key]) {
                    groups[key] = {
                        TypeDestinyName: item.TypeDestinyName || 'N/A',
                        TypeLineProcessName: item.TypeLineProcessName || 'N/A',
                        TypeProcessingPlantName: item.TypeProcessingPlantName || 'N/A',
                        TypeCultiveName: item.TypeCultiveName || 'N/A',
                        TypeCropName: item.TypeCropName || 'N/A',
                        VrtName: item.VrtName || 'N/A',
                        TotalQuantityJaba: 0,
                        TotalWeightAverageParihuela: 0
                    };
                }
                groups[key].TotalQuantityJaba += quantity;
                groups[key].TotalWeightAverageParihuela += weight;
            });
            return Object.values(groups);
        },
        totalQuantityJabasSum() {
            if (!this.selected) return 0;
            return this.selected.reduce((acc, item) => acc + parseFloat(item.LlpQuantityJaba ?? item.SppQuantityJaba ?? item.QuantityJaba ?? item.Quantity ?? item.xCount ?? 0), 0);
        },
        totalWeightSum() {
            if (!this.selected) return 0;
            return this.selected.reduce((acc, item) => acc + parseFloat(item.WeightAverageParihuela ?? item.LppWeightAverageLot ?? item.PldWeight ?? 0), 0);
        }
    },
    watch: {
        selectedSearch(val) {
            this.viewItemSearch = (val && val.length > 0) ? val[val.length - 1] : {};
            this.itemsDetail = [];
            this.sumTotalBoxes = 0;
            this.Quantity = 0;
            this.RcfIDCheck = 0;
            this.boxeAproximate = 0;
            this.selectedStretcher = this.selected.length > 0 ? [this.selected[0]] : [];
        },
        itemsDetail: {
            handler() {
                this.sumTotalBoxes = this.isSumBoxes();
            },
            deep: true
        },
        'filter.TypeDestiny'() {
            this.selected = [];
            this.selectedStretcher = [];
            this.RcfIDCheck = 0;
        },
        'filter.TypeCultive'() {
            this.selected = [];
            this.selectedStretcher = [];
            this.RcfIDCheck = 0;
        },
        TypeProcessingPlant(val) {
            if (val != 2) {
                this.TypeBaler = null;
            }
            this.selected = [];
            this.selectedStretcher = [];
            this.RcfIDCheck = 0;
        },
        TypeLineProcess() {
            this.selected = [];
            this.selectedStretcher = [];
            this.RcfIDCheck = 0;
        }
    },
    methods: {
        confirmAddOrder() {
            if (!this.orderToSelect) return;
            const alreadyExists = (this.selectedSearch || []).some(x => x.UwoOrderProductionID === this.orderToSelect.UwoOrderProductionID);
            if (!alreadyExists) {
                this.selectedSearch = [...this.selectedSearch, this.orderToSelect];
            }
            this.orderToSelect = null;
        },
        filterOrderProduction(item, queryText, itemText) {
            if (!item) return false;
            if (!queryText) return true;
            const query = String(queryText).toLowerCase().trim();
            if (!query) return true;

            const op = String(item.UwoOrderProductionID || '').toLowerCase();
            const customer = String(item.UwoCustomerName || '').toLowerCase();
            const materialList = String(item.UwoMaterialListID || '').toLowerCase();
            const materialListName = String(item.UwoMaterialListName || '').toLowerCase();
            const crop = String(item.TypeCropName || '').toLowerCase();
            const cultive = String(item.TypeCultiveName || '').toLowerCase();
            const center = String(item.UfdProductionCenter || '').toLowerCase();
            const plant = String(item.UwoPlantProcessing || '').toLowerCase();
            const boxes = String(item.UwoMaterialListNumberBoxes || '').toLowerCase();

            return op.includes(query) ||
                customer.includes(query) ||
                materialList.includes(query) ||
                materialListName.includes(query) ||
                crop.includes(query) ||
                cultive.includes(query) ||
                center.includes(query) ||
                plant.includes(query) ||
                boxes.includes(query);
        },
        isOrderSelected(item) {
            if (!this.selectedSearch || !item) return false;
            return this.selectedSearch.some(x => x.UwoOrderProductionID === item.UwoOrderProductionID);
        },
        removeSelectedOrder(item, idx) {
            if (!item) return;

            // 1. Si contiene presentaciones agregadas, devolver su peso a los lotes correspondientes
            if (item.presentationsAdded && item.presentationsAdded.length > 0) {
                item.presentationsAdded.forEach(pres => {
                    const weightToReturn = parseFloat(pres.TotalWeight || 0);
                    if (weightToReturn > 0) {
                        const lotsToUpdate = new Set();
                        (this.selected || []).forEach(x => {
                            if ((pres.LlpID && x.LlpID === pres.LlpID) || (pres.RcfID && x.RcfID === pres.RcfID)) {
                                lotsToUpdate.add(x);
                            }
                        });
                        if (this.selectedStretcher && this.selectedStretcher[0]) {
                            const sLot = this.selectedStretcher[0];
                            if ((pres.LlpID && sLot.LlpID === pres.LlpID) || (pres.RcfID && sLot.RcfID === pres.RcfID)) {
                                lotsToUpdate.add(sLot);
                            }
                        }
                        (this.itemsStretcher || []).forEach(x => {
                            if ((pres.LlpID && x.LlpID === pres.LlpID) || (pres.RcfID && x.RcfID === pres.RcfID)) {
                                lotsToUpdate.add(x);
                            }
                        });

                        lotsToUpdate.forEach(lot => {
                            lot.LppWeightAverageLot = parseFloat(lot.LppWeightAverageLot || 0) + weightToReturn;
                        });
                    }
                });
                this.$set(item, 'presentationsAdded', []);
            }

            // 2. Limpiar valores temporales de cálculo y selección en la orden
            this.$set(item, 'PresentationBoxID', null);
            this.$set(item, 'qtyBoxesToCreate', null);
            this.$set(item, 'calculatedBoxes', null);
            this.$set(item, 'calculatedRemainder', null);

            // 3. Quitar de selectedSearch
            const targetIndex = (idx !== undefined && idx !== null)
                ? idx
                : (this.selectedSearch || []).findIndex(x => x.UwoOrderProductionID === item.UwoOrderProductionID);

            if (targetIndex !== -1 && this.selectedSearch) {
                this.selectedSearch.splice(targetIndex, 1);
                this.selectedSearch = [...this.selectedSearch];
            }

            // 4. Si la orden estaba seleccionada en orderToSelect temporalmente, resetear
            if (this.orderToSelect && this.orderToSelect.UwoOrderProductionID === item.UwoOrderProductionID) {
                this.orderToSelect = null;
            }

            // 5. Recalcular las tarjetas restantes en selectedSearch con el peso restituido
            if (this.selectedSearch && this.selectedSearch.length > 0) {
                this.selectedSearch.forEach(card => {
                    if (card.PresentationBoxID) {
                        this.calculatePresentationBox(card);
                    }
                });
            }
        },
        rowClickSearch: function (item, row) {
            if (item !== undefined) {
                row.select(!row.isSelected);
                console.log("viewItemSearch", JSON.parse(JSON.stringify(this.viewItemSearch)));
            }
        },
        isLotSelected(item) {
            if (!this.selectedStretcher || this.selectedStretcher.length === 0 || !this.selectedStretcher[0]) {
                return false;
            }
            const sel = this.selectedStretcher[0];
            return sel.RcfID === item.RcfID || (sel.LlpID && sel.LlpID === item.LlpID);
        },
        hasCertification(item) {
            if (!item || !item.TcDescription) return false;
            const val = String(item.TcDescription).trim().toLowerCase();
            return val !== '' && val !== 'no' && val !== 'n/a' && val !== 'ninguno' && val !== 'ninguna' && val !== 'sin certificacion' && val !== '0';
        },
        selectLotCard(item) {
            this.rowClickStretcher(item);
        },
        onGetPresentations(items) {
            this.presentationsList = items;
        },
        getSelectedLotAvailableWeight() {
            if (this.selectedStretcher && this.selectedStretcher.length > 0 && this.selectedStretcher[0]) {
                const lot = this.selectedStretcher[0];
                return Math.max(0, parseFloat(lot.LppWeightAverageLot || 0) - parseFloat(lot.PldWeight || 0));
            }
            if (this.selected && this.selected.length === 1 && this.selected[0]) {
                const lot = this.selected[0];
                return Math.max(0, parseFloat(lot.LppWeightAverageLot || 0) - parseFloat(lot.PldWeight || 0));
            }
            return 0;
        },
        calculatePresentationBox(item) {
            if (!this.presentationsList) return;
            const definition = this.presentationsList.find(x => x.DedValue === item.PresentationBoxID);
            if (!definition) return;
            const helper = parseFloat(definition.DedHelper || 0);
            if (helper <= 0) return;

            const currentLotWeight = this.getSelectedLotAvailableWeight();
            const calculatedBoxes = Math.floor(currentLotWeight / helper);
            const calculatedRemainder = (currentLotWeight % helper).toFixed(4);

            this.$set(item, 'calculatedBoxes', calculatedBoxes);
            this.$set(item, 'calculatedRemainder', calculatedRemainder);

            const usedWeight = this.getTotalUsedWeight(item);
            const remainingClientWeight = Math.max(0, item.UwoPlannedQty - usedWeight);
            const maxAllowedByClient = Math.floor(remainingClientWeight / helper);

            this.$set(item, 'qtyBoxesToCreate', Math.min(calculatedBoxes, maxAllowedByClient));
        },
        getPresentationHelper(item) {
            if (!this.presentationsList || !item.PresentationBoxID) return 0;
            const definition = this.presentationsList.find(x => x.DedValue === item.PresentationBoxID);
            if (!definition) return 0;
            return parseFloat(definition.DedHelper || 0);
        },
        getTotalUsedWeight(item) {
            if (!item.presentationsAdded) return 0;
            return item.presentationsAdded.reduce((acc, pres) => acc + pres.TotalWeight, 0);
        },
        validateBoxesInput(item) {
            if (!this.presentationsList || !item.PresentationBoxID) return;
            const definition = this.presentationsList.find(x => x.DedValue === item.PresentationBoxID);
            if (!definition) return;
            const helper = parseFloat(definition.DedHelper || 0);
            if (helper <= 0) return;

            const inputVal = parseFloat(item.qtyBoxesToCreate || 0);
            const weightToCreate = inputVal * helper;
            const currentLotWeight = this.getSelectedLotAvailableWeight();

            if (weightToCreate > currentLotWeight) {
                const maxByWeight = Math.floor(currentLotWeight / helper);
                this.$set(item, 'qtyBoxesToCreate', maxByWeight);
                this.$fun.alert("La cantidad de cajas ingresada supera los KG Disponibles en el Lote Seleccionado.", "warning");
                return;
            }

            const usedWeight = this.getTotalUsedWeight(item);
            if (weightToCreate + usedWeight > item.UwoPlannedQty) {
                const remainingWeight = Math.max(0, item.UwoPlannedQty - usedWeight);
                const maxByClient = Math.floor(remainingWeight / helper);
                this.$set(item, 'qtyBoxesToCreate', maxByClient);
                this.$fun.alert("La cantidad de cajas ingresada supera el peso planificado para este cliente.", "warning");
            }
        },
        async addPresentationToArray(item) {
            // 1. Validar selección de Lote
            const lots = this.selected || [];
            if (lots.length === 0) {
                this.$fun.alert("Debe tener al menos un Lote Seleccionado en la tabla.", "warning");
                return;
            }

            if (lots.length === 1) {
                if (!this.selectedStretcher || this.selectedStretcher.length === 0 || !this.selectedStretcher[0]) {
                    this.selectedStretcher = [lots[0]];
                    this.RcfIDCheck = lots[0].RcfID;
                }
            } else if (lots.length > 1) {
                if (!this.selectedStretcher || this.selectedStretcher.length === 0 || !this.selectedStretcher[0]) {
                    this.$fun.alert("Debe seleccionar un lote de la tabla Lotes Seleccionados.", "warning");
                    return;
                }
            }

            const currentLot = this.selectedStretcher[0];
            if (!currentLot) {
                this.$fun.alert("Debe seleccionar un lote de la tabla Lotes Seleccionados.", "warning");
                return;
            }

            // 2. Validar Parámetro de Tratamiento Cooling (USA) si aplica
            if (this.ParamValidate == 1) {
                if (this.SecCreate !== null && this.SecCreate !== '' && currentLot.DateEndCooling > this.SecCreate) {
                    this.$fun.alert(
                        "La Fecha fin de enfriamiento de tratamiento de la parihuela: " + currentLot.LlpID +
                        ", del lote: " + currentLot.RcfID +
                        " tiene que ser menor a la fecha de creación del Pallet.",
                        "warning"
                    );
                    return;
                }
            }

            // 3. Validar Presentación, Calibre y Cajas
            if (!this.presentationsList || !item.PresentationBoxID || item.PresentationBoxID <= 0) {
                this.$fun.alert("Debe seleccionar una Presentación antes de agregar.", "warning");
                return;
            }
            if (!this.objCaliber) {
                this.$fun.alert("Seleccione un calibre", "warning");
                return;
            }
            const definition = this.presentationsList.find(x => x.DedValue === item.PresentationBoxID);
            if (!definition) return;
            const helper = parseFloat(definition.DedHelper || 0);
            if (helper <= 0) return;

            const qty = parseFloat(item.qtyBoxesToCreate || 0);
            if (qty <= 0) {
                this.$fun.alert("La cantidad de cajas debe ser mayor a 0.", "warning");
                return;
            }

            const weight = qty * helper;

            // 4. Validar disponibilidad de peso en el LOTE seleccionado
            const lotAvailableWeight = parseFloat(currentLot.LppWeightAverageLot || 0) - parseFloat(currentLot.PldWeight || 0);
            if (weight > lotAvailableWeight) {
                this.$fun.alert("La cantidad de Kg (" + weight.toFixed(2) + " kg) supera los Kg Disponibles en el Lote seleccionado (" + lotAvailableWeight.toFixed(2) + " kg).", "warning");
                return;
            }

            // 5. Validar disponibilidad de peso en el CLIENTE (UwoPlannedQty)
            const usedWeightClient = this.getTotalUsedWeight(item);
            if (weight + usedWeightClient > item.UwoPlannedQty) {
                this.$fun.alert("No se puede agregar. Supera el peso planificado para este cliente.", "warning");
                return;
            }

            // 6. Validar compatibilidad de Tipo de Cultivo y Variedad
            if (item.TypeCropName === "ORGÁNICO" && currentLot.TypeCropName && item.TypeCropName !== currentLot.TypeCropName) {
                this.$fun.alert("El Tipo de Cultivo de la Orden de Producción es ==> " + item.TypeCropName + " y del Lote es ==> " + currentLot.TypeCropName, "warning");
                return;
            }

            if (!item.presentationsAdded) {
                this.$set(item, 'presentationsAdded', []);
            }

            // 7. Agregar elemento a presentaciones del cliente
            item.presentationsAdded.push({
                PresentationBoxID: item.PresentationBoxID,
                PresentationBoxName: definition.DedDescription,
                DedHelper: helper,
                QtyBoxes: qty,
                TotalWeight: weight,
                _prevQtyBoxes: qty,
                _prevWeight: weight,
                RcfID: currentLot.RcfID,
                RcfCode: currentLot.RcfCode,
                LlpID: currentLot.LlpID,
                VrtID: currentLot.VrtID,
                VrtName: currentLot.VrtName,
                CaliberID: this.objCaliber ? this.objCaliber.DedValue : null,
                CaliberName: this.objCaliber ? this.objCaliber.DedDescription : ''
            });

            // 8. Descontar peso del lote seleccionado (reactividad en tabla de lotes)
            currentLot.LppWeightAverageLot = Math.max(0, currentLot.LppWeightAverageLot - weight);

            // 9. Reset de inputs de la tarjeta
            this.$set(item, 'PresentationBoxID', 0);
            this.$set(item, 'qtyBoxesToCreate', 0);
            this.$set(item, 'calculatedBoxes', 0);
            this.$set(item, 'calculatedRemainder', 0);
        },
        updatePresentationQty(item, pres) {
            const helper = parseFloat(pres.DedHelper || 0);
            if (helper <= 0) return;

            let newQty = parseFloat(pres.QtyBoxes || 0);
            if (newQty < 0) newQty = 0;

            const oldWeight = parseFloat(pres._prevWeight ?? pres.TotalWeight ?? 0);
            const newWeight = newQty * helper;
            const diffWeight = newWeight - oldWeight;

            // Buscar lote asociado a esta presentación
            const targetLot = (this.selected || []).find(x => x.RcfID === pres.RcfID) || (this.selectedStretcher ? this.selectedStretcher[0] : null);

            if (targetLot) {
                const availableInLot = parseFloat(targetLot.LppWeightAverageLot || 0) - parseFloat(targetLot.PldWeight || 0);
                if (diffWeight > availableInLot) {
                    const prevQty = parseFloat(pres._prevQtyBoxes ?? 0);
                    this.$fun.alert("La cantidad ingresada supera los KG Disponibles en el Lote (" + (availableInLot + oldWeight).toFixed(2) + " kg).", "warning");
                    this.$nextTick(() => {
                        pres.QtyBoxes = prevQty;
                        pres.TotalWeight = prevQty * helper;
                        this.$set(item, 'presentationsAdded', [...item.presentationsAdded]);
                    });
                    return;
                }
            }

            // Validar límite del Cliente (UwoPlannedQty)
            const otherWeightClient = item.presentationsAdded
                .filter(x => x !== pres)
                .reduce((acc, x) => acc + x.TotalWeight, 0);

            if (newWeight + otherWeightClient > item.UwoPlannedQty) {
                const prevQty = parseFloat(pres._prevQtyBoxes ?? 0);
                this.$fun.alert("La cantidad ingresada supera el peso planificado para este cliente.", "warning");
                this.$nextTick(() => {
                    pres.QtyBoxes = prevQty;
                    pres.TotalWeight = prevQty * helper;
                    this.$set(item, 'presentationsAdded', [...item.presentationsAdded]);
                });
                return;
            }

            // Aplicar cambio y ajustar el saldo del lote
            if (targetLot) {
                targetLot.LppWeightAverageLot = Math.max(0, targetLot.LppWeightAverageLot - diffWeight);
            }

            pres._prevQtyBoxes = newQty;
            pres._prevWeight = newWeight;
            pres.QtyBoxes = newQty;
            pres.TotalWeight = newWeight;

            this.$set(item, 'presentationsAdded', [...item.presentationsAdded]);
        },
        removePresentationFromArray(item, index) {
            if (item.presentationsAdded && item.presentationsAdded[index]) {
                const pres = item.presentationsAdded[index];
                const weightToReturn = parseFloat(pres.TotalWeight || 0);
                if (weightToReturn > 0) {
                    const lotsToUpdate = new Set();
                    (this.selected || []).forEach(x => {
                        if ((pres.LlpID && x.LlpID === pres.LlpID) || (pres.RcfID && x.RcfID === pres.RcfID)) {
                            lotsToUpdate.add(x);
                        }
                    });
                    if (this.selectedStretcher && this.selectedStretcher[0]) {
                        const sLot = this.selectedStretcher[0];
                        if ((pres.LlpID && sLot.LlpID === pres.LlpID) || (pres.RcfID && sLot.RcfID === pres.RcfID)) {
                            lotsToUpdate.add(sLot);
                        }
                    }
                    (this.itemsStretcher || []).forEach(x => {
                        if ((pres.LlpID && x.LlpID === pres.LlpID) || (pres.RcfID && x.RcfID === pres.RcfID)) {
                            lotsToUpdate.add(x);
                        }
                    });
                    lotsToUpdate.forEach(lot => {
                        lot.LppWeightAverageLot = parseFloat(lot.LppWeightAverageLot || 0) + weightToReturn;
                    });
                }
                item.presentationsAdded.splice(index, 1);
                this.$set(item, 'presentationsAdded', [...item.presentationsAdded]);
                if (item.PresentationBoxID) {
                    this.calculatePresentationBox(item);
                }
            }
        },
        openDialogAssignCustomers() {
            if (!this.selected || this.selected.length === 0) {
                this.$fun.alert("Debe seleccionar al menos un elemento.", "warning");
                return;
            }
            const first = this.selected[0];
            const firstCultive = first.TypeCultive !== undefined && first.TypeCultive !== null ? first.TypeCultive : this.filter.TypeCultive;
            const firstDestiny = first.TypeDestiny !== undefined && first.TypeDestiny !== null ? first.TypeDestiny : this.filter.TypeDestiny;

            const sameTypeCultive = this.selected.every(item => {
                const itemCultive = item.TypeCultive !== undefined && item.TypeCultive !== null ? item.TypeCultive : this.filter.TypeCultive;
                return itemCultive == firstCultive;
            });
            const sameTypeDestiny = this.selected.every(item => {
                const itemDestiny = item.TypeDestiny !== undefined && item.TypeDestiny !== null ? item.TypeDestiny : this.filter.TypeDestiny;
                return itemDestiny == firstDestiny;
            });

            if (!sameTypeCultive || !sameTypeDestiny) {
                this.$fun.alert("Los elementos seleccionados deben ser del mismo Cultivo y del mismo Destino.", "warning");
                return;
            }

            this.TypeDestiny = firstDestiny;
            this.selectedStretcher = this.selected.length > 0 ? [this.selected[0]] : [];
            this.itemsDetail = [];
            this.sumTotalBoxes = 0;
            this.Quantity = 0;
            this.RcfIDCheck = 0;
            this.boxeAproximate = 0;
            this.selectedSearch = [];
            this.orderToSelect = null;
            this.viewItemSearch = {};

            this.loadCustomerOrdersProduction(this.OrdAreProduction, firstCultive);
            this.dialogAssignCustomers = true;
        },
        loadCustomerOrdersProduction(OrdAreProduction, TypeCultive) {
            _sPackingService.GetSearch({ OrdAreProduction, TypeCultive }, this.$fun.getUserID()).then(r => {
                this.itemsSearch = r.data || [];
            });
        },
        rowSelected(rows) {
            this.selected = rows.length > 0 ? rows : [];
        },
        onChangeDestiny(event) {
            this.selected = [];
            this.selectedStretcher = [];
            this.RcfIDCheck = 0;
            if (event && event.length > 0) {
                const obj = event.find(x => x.DedValue == this.filter.TypeDestiny);
                this.OrdAreProduction = obj ? (obj.DedAbbreviation ?? '') : '';
                this.dgr = parseInt(obj ? (obj.DedHelper ?? 0) : 0);
                this.loadCustomerOrdersProduction(this.OrdAreProduction, this.filter.TypeCultive);
            }
            this.loadStretcher();
        },
        onChangeCultivo(value) {
            this.selected = [];
            this.selectedStretcher = [];
            this.RcfIDCheck = 0;
            this.loadCustomerOrdersProduction(this.OrdAreProduction, this.filter.TypeCultive);
            this.loadStretcher();
        },

        // Packing detail methods
        loadStretcher() {
            this.selected = [];
            this.selectedStretcher = [];
            this.RcfIDCheck = 0;
            this.itemsStretcher = [];
            var IsRework = (this.isReprocess) ? 1 : null;
            this.LoadingStretcher = true;
            const params = {
                TypeDestiny: this.filter.TypeDestiny || this.TypeDestiny,
                TypeProcessingPlant: this.TypeProcessingPlant,
                IsRework: IsRework,
                TypeLineProcess: this.TypeLineProcess,
                TypeBaler: this.TypeBaler,
                BeginDate: this.filter.BeginDate,
                EndDate: this.filter.EndDate,
                TypeCultive: this.filter.TypeCultive
            };

            _sPackingService.GetStretcher(params, this.$fun.getUserID()).then(r => {
                this.itemsStretcher = r.data || [];
                this.LoadingStretcher = false;
                if (this.itemsDetail.length > 0) {
                    this.itemsStretcher.forEach(element => {
                        this.getDiference(element);
                    });
                }
            }).catch(() => {
                this.LoadingStretcher = false;
            });
        },
        rowClickStretcher(item, row) {
            if (item !== undefined) {
                this.selectedStretcher = [item];
                this.RcfIDCheck = this.selectedStretcher[0].RcfID;
                if (this.selectedSearch && this.selectedSearch.length > 0) {
                    this.selectedSearch.forEach(card => {
                        if (card.PresentationBoxID) {
                            this.calculatePresentationBox(card);
                        }
                    });
                }
            }
        },
        async newItem() {
            let val = this.selectedStretcher[0];
            if (!val) {
                this.$fun.alert("Seleccione un Lote de Producción", "warning");
                return;
            }
            val.Quantity = this.Quantity;

            var IsReworkP = (this.isReprocess) ? 1 : null;

            try {
                const r = await _sGenParamService.search({ PrmName: "ValidarFecTratamientoEmpaqueUSA" }, this.$fun.getUserID());
                this.ParamValidate = r.data.PrmValue;

                if (this.ParamValidate == 1) {
                    if (this.SecCreate !== null && this.SecCreate !== '' && val.DateEndCooling > this.SecCreate) {
                        this.$fun.alert(
                            "La Fecha fin de enfriamiento de tratamiento de la parihuela: " + val.LlpID +
                            ", del lote: " + val.RcfID +
                            " tiene que ser menor a la fecha de creación del Pallet.",
                            "warning"
                        );
                        return;
                    }
                }
            } catch (error) {
                console.error("Error al obtener el Parametro de validacion:", error);
                return;
            }

            if (this.Quantity > this.boxeAproximate) {
                this.$fun.alert("La cantidad de Cajas supera las cajas Disponibles", "warning");
                return;
            }

            if (!this.isValidatedDetail(val)) {
                return;
            }

            let exist = false;
            this.itemsDetail.forEach(element => {
                if (val.VrtID !== element.VrtID) {
                    exist = true;
                    this.$fun.alert(
                        "No se puede armar Parihuela con diferente variedad",
                        "warning",
                    );
                }
            });

            if (exist == false) {
                var PldLine = this.itemsDetail.length + 1;
                let item = {
                    PldLine: PldLine,
                    PldID: 0,
                    PltID: 0,
                    RcfID: val.RcfID,
                    RcfCode: val.RcfCode,
                    FagID: val.FagID,
                    LlpID: val.LlpID,
                    LppID: val.LppID,
                    TypeCaliberName: this.objCaliber ? this.objCaliber.DedDescription : '',
                    TypeCaliber: this.objCaliber ? this.objCaliber.DedValue : '',
                    VrtID: val.VrtID,
                    VrtName: val.VrtName,
                    PldQuantityBoxes: this.Quantity,
                    PldFruitxBoxe: this.pldFruitxBoxe,
                    PldNumInSale: this.viewItemSearch.NumInSale,
                    TypeZonLocationName: val.TypeZonLocationName,
                    TypePriority: val.TypePriority,
                    SecStatus: 1,
                    UsrCreateID: this.$fun.getUserID(),
                    TypeDestiny: this.TypeDestiny,
                    IsReworkP: IsReworkP,
                    TypeLine: this.TypeLineProcess
                };

                var diferenceeDis = this.selectedStretcher[0].LppWeightAverageLot - (this.selectedStretcher[0].PldWeight || 0);
                var diferencee = (this.Quantity * this.viewItemSearch.NumInSale);

                if (diferencee > diferenceeDis) {
                    this.$fun.alert("La cantidad de Kg supera las Kg Disponibles", "warning");
                    return;
                }

                this.VrtID = val.VrtID;
                this.itemsDetail.push(item);

                this.selectedStretcher[0].LppWeightAverageLot = (diferenceeDis - diferencee) + (this.selectedStretcher[0].PldWeight || 0);
            }
        },
        removeItem(item) {
            var weight = (item.PldNumInSale || 0) * (item.PldQuantityBoxes || 0);

            if (this.itemsDetail.length > 0) {
                if (item.PldID > 0) {
                    this.itemRemoved.push(
                        this.itemsDetail.filter(x => x.PldLine == item.PldLine)[0],
                    );
                    this.itemRemoved.forEach(element => {
                        element.SecStatus = 0;
                    });
                }

                this.itemsDetail = this.itemsDetail.filter(
                    x => x.PldLine != item.PldLine,
                );
                if (weight <= 0) {
                    return;
                }
                let keyExist = 0;
                this.itemsStretcher.forEach(element => {
                    if (item.LppID != null) {
                        if (element.LppID == item.LppID) {
                            element.LppWeightAverageLot = element.LppWeightAverageLot + weight;
                            keyExist = 1;
                        }
                    } else {
                        if (element.RcfID == item.RcfID) {
                            element.LppWeightAverageLot = element.LppWeightAverageLot + weight;
                            keyExist = 1;
                        }
                    }
                });

                item.LppWeightAverageLot = weight;
                item.PldWeight = 0;

                if (keyExist == 0) {
                    this.itemsStretcher.push(item);
                }

                this.orderDetails();
            }
        },
        orderDetails() {
            let i = 0;
            this.itemsDetail.forEach(e => {
                i++;
                e.PldLine = i;
            });
        },
        isValidatedDetail(item) {
            var isValidated = true;
            if (
                this.viewItemSearch.UwoMaterialListNumberBoxes == undefined ||
                this.viewItemSearch.UwoMaterialListNumberBoxes == 0
            ) {
                this.$fun.alert("Debe Seleccionar una Orden de Produccion", "warning");
                return false;
            }

            if (item == undefined) {
                this.$fun.alert("Seleccione un Lote de Produccion", "warning");
                return false;
            }

            if (this.Quantity <= 0) {
                if (this.$refs.Quantity && this.$refs.Quantity.error) {
                    this.$refs.Quantity.error("La cantidad debe ser mayor a 0");
                } else {
                    this.$fun.alert("La cantidad debe ser mayor a 0", "warning");
                }
                isValidated = false;
                return false;
            }

            if (this.pldFruitxBoxe <= 0) {
                if (this.$refs.pldFruitxBoxe && this.$refs.pldFruitxBoxe.error) {
                    this.$refs.pldFruitxBoxe.error("Ingrese Fruta x Caja");
                } else {
                    this.$fun.alert("Ingrese Fruta x Caja", "warning");
                }
                isValidated = false;
                return false;
            }

            if (this.objCaliber == null) {
                if (this.$refs.TypeCaliber && this.$refs.TypeCaliber.error) {
                    this.$refs.TypeCaliber.error("Seleccione un calibre");
                } else {
                    this.$fun.alert("Seleccione un calibre", "warning");
                }
                isValidated = false;
                return false;
            }

            if (this.Quantity > this.isDifferenceBoxes()) {
                this.$fun.alert(
                    "Esta superando la Cantidad de Cajas solicitadas segun Orden de Produccion",
                    "warning",
                );
                isValidated = false;
                return false;
            }

            if (this.isDifferenceCultive(item) > 0) {
                this.$fun.alert(
                    "La plantilla seleccionada tiene un cultivo diferente al que desea agregar",
                    "warning",
                );
                isValidated = false;
                return false;
            }

            if (this.viewItemSearch.TypeCropName === "ORGÁNICO") {
                if (this.viewItemSearch.TypeCropName !== item.TypeCropName) {
                    this.$fun.alert(
                        "El Tipo de Cultivo de la Orden de Produccion es ==> " +
                        this.viewItemSearch.TypeCropName +
                        " y el Tipo de Cultivo del Lote de Producción es ==> " +
                        item.TypeCropName +
                        ", No se puede agregar. Contacte con el Area de Produccion",
                        "warning",
                    );
                    isValidated = false;
                    return false;
                }
            }

            return isValidated;
        },
        getLotRepresentative() {
            var max = 0;
            var LotID = 0;
            this.itemsDetail.forEach(element => {
                if (max <= element.PldQuantityBoxes) {
                    max = element.PldQuantityBoxes;
                    LotID = element.RcfID;
                }
            });
            return LotID;
        },
        getFundRepresentative() {
            var max = 0;
            var FagID = 0;
            this.itemsDetail.forEach(element => {
                if (max <= element.PldQuantityBoxes) {
                    max = element.PldQuantityBoxes;
                    FagID = element.FagID;
                }
            });
            return FagID;
        },
        getLocationName() {
            let locationName = this.getLocations(this.itemsDetail);
            let cantTotal = [];
            let priorityTotal = [];

            this.itemsDetail.forEach((element) => {
                for (var i = 0; i < locationName.length; i++) {
                    if (element.TypeZonLocationName === locationName[i]) {
                        cantTotal[i] = (cantTotal[i] == undefined ? 0 : cantTotal[i]) + parseInt(element.PldQuantityBoxes);
                        let currentPriority = parseInt(element.TypePriority) || 0;
                        priorityTotal[i] = (priorityTotal[i] == undefined ? 0 : priorityTotal[i]);
                        if (currentPriority > priorityTotal[i]) {
                            priorityTotal[i] = currentPriority;
                        }
                    }
                }
            });

            let mayor = -1;
            let maxPriority = -1;
            let index = -1;

            for (let i = 0; i < cantTotal.length; i++) {
                let qty = cantTotal[i] || 0;
                let prio = priorityTotal[i] || 0;

                if (qty > mayor || (qty === mayor && prio > maxPriority)) {
                    mayor = qty;
                    maxPriority = prio;
                    index = i;
                }
            }

            if (index !== -1) {
                return locationName[index];
            }
            return "";
        },
        getLocations(items) {
            let locations = [];
            items.forEach(element => {
                if (locations.indexOf(element.TypeZonLocationName) === -1) {
                    locations.push(element.TypeZonLocationName);
                }
            });
            return locations;
        },
        difTypeLine() {
            let typeLine = [];
            let message = "";
            this.itemsDetail.forEach(element => {
                if (typeLine.indexOf(element.TypeLine) === -1) {
                    if (typeLine.length != 0) { message = "Atención!!! esta registrando de diferente linea"; }
                    typeLine.push(element.TypeLine);
                }
            });
            return message;
        },
        isDifferenceBoxes() {
            var difference = 0;
            if (this.viewItemSearch) {
                difference = (this.viewItemSearch.UwoMaterialListNumberBoxes || 0) - this.sumTotalBoxes;
            }
            return difference;
        },
        isDifferenceCultive(item) {
            var difference = 0;
            if (this.viewItemSearch != null) {
                if (this.viewItemSearch.TypeCultive != item.TypeCultive) {
                    difference = 1;
                }
            }
            return difference;
        },
        isSumBoxes() {
            var total = 0;
            if (this.itemsDetail.length > 0) {
                this.itemsDetail.forEach(element => {
                    total += parseInt(element.PldQuantityBoxes || 0);
                });
            }
            return total;
        },
        inputSumBoxes() {
            this.sumTotalBoxes = this.isSumBoxes();
        },
        inputCaliber(item) {
            if (item !== null) {
                this.pldFruitxBoxe = item.DedHelper;
            }
        },
        filtReprocess() {
            this.loadStretcher();
        },
        clickHide(item) {
            let itemSend = {};
            itemSend.LppID = item.LppID;
            itemSend.RcfID = item.RcfID;
            itemSend.TypeDestiny = this.TypeDestiny;

            this.$fun.alert("¿ Seguro de ocultar parihuela ?", "question").then(resp => {
                if (resp.value) {
                    _sPackingService.HideParihuela(itemSend, this.$fun.getUserID()).then(data => {
                        if (data.status == 200) {
                            this.loadStretcher();
                        }
                    });
                }
            });
        },
        getDiference(item) {
            this.selectedStretcher = [item];
            if (this.itemsDetail.length > 0) {
                this.itemsDetail.forEach(element => {
                    var itemD = element;
                    var diferenceeDis = this.selectedStretcher[0].LppWeightAverageLot - this.selectedStretcher[0].PldWeight;
                    var diferencee = (itemD.PldQuantityBoxes * this.viewItemSearch.NumInSale);

                    if (itemD.LlpID != null) {
                        if (item.LlpID == itemD.LlpID) {
                            this.selectedStretcher[0].LppWeightAverageLot = (diferenceeDis - diferencee) + this.selectedStretcher[0].PldWeight;
                        }
                    } else {
                        if (this.selectedStretcher[0].RcfID == itemD.RcfID) {
                            this.selectedStretcher[0].LppWeightAverageLot = (diferenceeDis - diferencee) + this.selectedStretcher[0].PldWeight;
                        }
                    }
                });
            }
        },
        saveAssignment() {
            if (this.viewItemSearch.UwoOrderProductionID == undefined) {
                this.$fun.alert("Seleccione una Orden de Produccion", "warning");
                return;
            }
            if (this.itemsDetail.length == 0) {
                this.$fun.alert("No existe Detalle de Empaque", "warning");
                return;
            }

            if (this.sumTotalBoxes !== this.viewItemSearch.UwoMaterialListNumberBoxes) {
                this.$fun.alert(
                    "El Total de Cajas no coincide con el Nro. de Cajas permitidas por el Producto Terminado",
                    "warning",
                );
                return;
            }

            let val = {
                PltID: 0,
                PltDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                PltWeightNet: this.sumTotalBoxes * this.viewItemSearch.NumInSale,
                PltGrossWeight: 0,
                UwoMaterialListNumberBoxes: this.sumTotalBoxes,
                UwoMaterialListID: this.viewItemSearch.UwoMaterialListID,
                UwoCustomerID: this.viewItemSearch.UwoCustomerID,
                UwoOrderProductionID: this.viewItemSearch.UwoOrderProductionID,
                TypeLine: this.TypeLineProcess,
                UfdProductionCenter: this.viewItemSearch.UfdProductionCenter,
                UfdProductionCenterID: this.viewItemSearch.UfdProductionCenterID,
                TypeDestinyPacking: this.OrdAreProduction,
                TypeBalance: this.typeBalance,
                TypeCultive: this.viewItemSearch.TypeCultive,
                TypeCrop: this.viewItemSearch.TypeCrop,
                VrtID: this.VrtID,
                PltFruitxBoxe: this.pldFruitxBoxe,
                FagIDRepresentative: this.getFundRepresentative(),
                RcfIDRepresentative: this.getLotRepresentative(),
                RePacking: 1,
                SecStatus: 1,
                UsrCreateID: this.$fun.getUserID(),
                itemsDetail: [...this.itemsDetail, ...this.itemRemoved],
                ZonLocationName: this.getLocationName()
            };

            this.$fun.alert("¿Seguro de guardar la asignación?", "question").then(resp => {
                if (resp.value) {
                    _sPackingService.save(val, this.$fun.getUserID()).then(r => {
                        if (r.status == 200) {
                            this.$fun.alert("Operación realizada correctamente", "success");
                            this.dialogAssignCustomers = false;
                            this.selected = [];
                            this.loadStretcher();
                        }
                    }).catch(err => {
                        this.$fun.alert("Error al guardar: " + (err.response?.data || err.message), "error");
                    });
                }
            });
        }
    },
};
</script>

<style scoped>
.table-row-hover:hover {
    background-color: #f1f5f9 !important;
}

.border-light {
    border: 1px solid #e2e8f0 !important;
}

.border-top {
    border-top: 1px solid #e2e8f0 !important;
}

.hover-scale {
    transition: transform 0.2s ease-in-out;
}

.hover-scale:hover {
    transform: scale(1.05);
}

/* Modern search input styling */
.modern-search-input>>>.v-input__control {
    min-height: 36px !important;
}

.modern-search-input>>>.v-input__slot {
    background-color: #f1f5f9 !important;
    /* Tailwind slate-100 */
    border: 1px solid transparent !important;
    transition: all 0.2s ease-in-out !important;
    padding: 0 16px !important;
}

.modern-search-input.v-input--is-focused>>>.v-input__slot {
    background-color: #ffffff !important;
    border-color: #6366f1 !important;
    /* Indigo-500 */
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;
}

.modern-search-input>>>.v-icon {
    color: #64748b !important;
    /* Tailwind slate-500 */
}

.custom-center-input>>>input {
    text-align: center;
}

.custom-center-input>>>.v-input__control {
    min-height: 28px !important;
    height: 28px !important;
}

.custom-center-input>>>.v-input__slot {
    min-height: 28px !important;
    height: 28px !important;
    padding: 0 4px !important;
}

.btn-assign-customers.v-btn--disabled {
    background-color: #f1f5f9 !important;
    color: #94a3b8 !important;
    box-shadow: none !important;
    border: 1px solid #cbd5e1 !important;
}

.btn-assign-customers.v-btn--disabled .v-icon {
    color: #94a3b8 !important;
}

/* Estilos para el Buscador Searchable de Órdenes */
.border-bottom-item {
    border-bottom: 1px solid #f1f5f9;
}

.border-bottom-item:last-child {
    border-bottom: none;
}

.btn-confirm-order.v-btn--disabled {
    background-color: #f1f5f9 !important;
    color: #94a3b8 !important;
    box-shadow: none !important;
    border: 1px solid #cbd5e1 !important;
    opacity: 0.85 !important;
}

/* Estilos para la Tabla de Selección de Lotes */
.lot-selection-table table tbody tr.lot-table-row {
    transition: background-color 0.15s ease, border-left-color 0.15s ease;
}

.lot-selection-table table tbody tr.lot-table-row:hover {
    background-color: #f1f5f9 !important;
}

.lot-selection-table table tbody tr.lot-table-row.is-selected:hover {
    background-color: #ecfdf5 !important;
}
</style>
